export default __webpack_public_path__ + "static/media/u2.0c321e84.svg";